import { render, staticRenderFns } from "./PersonaliseBundle.vue?vue&type=template&id=4011bdf2&scoped=true"
import script from "./PersonaliseBundle.vue?vue&type=script&lang=js"
export * from "./PersonaliseBundle.vue?vue&type=script&lang=js"
import style0 from "./PersonaliseBundle.vue?vue&type=style&index=0&id=4011bdf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4011bdf2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BasketModal: require('/nfs_storage_drive/xen1.powertext.co.uk/servers/togglenode1/webstore/components/BasketModal.vue').default})
